/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ActivityFull } from './ActivityFull';
import {
    ActivityFullFromJSON,
    ActivityFullFromJSONTyped,
    ActivityFullToJSON,
} from './ActivityFull';
import type { TrackFull } from './TrackFull';
import {
    TrackFullFromJSON,
    TrackFullFromJSONTyped,
    TrackFullToJSON,
} from './TrackFull';

/**
 * 
 * @export
 * @interface TrackActivityFull
 */
export interface TrackActivityFull extends ActivityFull {
    /**
     * 
     * @type {string}
     * @memberof TrackActivityFull
     */
    itemType: TrackActivityFullItemTypeEnum;
    /**
     * 
     * @type {TrackFull}
     * @memberof TrackActivityFull
     */
    item: TrackFull;
}


/**
 * @export
 */
export const TrackActivityFullItemTypeEnum = {
    Track: 'track'
} as const;
export type TrackActivityFullItemTypeEnum = typeof TrackActivityFullItemTypeEnum[keyof typeof TrackActivityFullItemTypeEnum];


/**
 * Check if a given object implements the TrackActivityFull interface.
 */
export function instanceOfTrackActivityFull(value: object): value is TrackActivityFull {
    let isInstance = true;
    isInstance = isInstance && "itemType" in value && value["itemType"] !== undefined;
    isInstance = isInstance && "item" in value && value["item"] !== undefined;

    return isInstance;
}

export function TrackActivityFullFromJSON(json: any): TrackActivityFull {
    return TrackActivityFullFromJSONTyped(json, false);
}

export function TrackActivityFullFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackActivityFull {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...ActivityFullFromJSONTyped(json, ignoreDiscriminator),
        'itemType': json['item_type'],
        'item': TrackFullFromJSON(json['item']),
    };
}

export function TrackActivityFullToJSON(value?: TrackActivityFull | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ActivityFullToJSON(value),
        'item_type': value.itemType,
        'item': TrackFullToJSON(value.item),
    };
}

